import { render, staticRenderFns } from "./VerifyPhoneOtp.vue?vue&type=template&id=79feb141"
import script from "./VerifyPhoneOtp.vue?vue&type=script&lang=js"
export * from "./VerifyPhoneOtp.vue?vue&type=script&lang=js"
import style0 from "./VerifyPhoneOtp.vue?vue&type=style&index=0&id=79feb141&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports